// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import bem from '@justpark/helpers/src/bem/bem';
import { useDispatch } from 'react-redux';
import FilterIcon from '@justpark/ui/src/components/Icons/FilterIcon';
import { toggleFilterPanel } from '../../../stores/search';
import { getQueryParam } from '../../../helpers/utils';
import { gtagTrack } from '../../../helpers/Tracking/Analytics';

import '../../../../static/scss/components/searchFilters/searchResultsFilterButton.scss';

const className = 'c-search-results-filter-button';

type Props = {
  searchQuery: string
};

const SearchResultsFilterButton = ({ searchQuery }: Props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const togglePanel = () => {
    gtagTrack('srp_filter_menu');
    dispatch(toggleFilterPanel());
  };

  const filterString = getQueryParam(searchQuery, 'filters');
  const { length: filterLength } = filterString ? filterString.split(',') : [];
  const lengthFormatted = filterLength > 9 ? `9+` : filterLength;

  return (
    <button className={className} type="button" onClick={togglePanel}>
      <FilterIcon type="secondary" />
      {filterLength > 0 && (
        <div className={bem(className, 'counter')}>
          <span>{lengthFormatted}</span>
        </div>
      )}

      <p className={bem(className, 'description')}>
        {t('search:filters', 'Filters')}
      </p>
    </button>
  );
};

export default SearchResultsFilterButton;
